// extracted by mini-css-extract-plugin
export default {"container":"Precio_container__Zkmny","logo":"Precio_logo__OCie7","detailcontainer":"Precio_detailcontainer__MgL2O","boxImg":"Precio_boxImg__24c+0"};